
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5.352c0-.875.2-1.66.602-2.352a4.721 4.721 0 011.695-1.695A4.492 4.492 0 019.648.648c.875 0 1.66.22 2.352.657.73.4 1.294.966 1.695 1.695.438.693.657 1.477.657 2.352 0 .838-.22 1.622-.657 2.351A4.72 4.72 0 0112 9.398c-.693.401-1.477.602-2.352.602-.838 0-1.622-.2-2.351-.602a5.377 5.377 0 01-1.695-1.695A4.803 4.803 0 015 5.352zm5.086 7c-.656-.037-1.404 0-2.242.109-.839.11-1.696.292-2.57.547a13.33 13.33 0 00-2.462.984c-.729.365-1.33.802-1.804 1.313C.57 15.815.352 16.38.352 17v2.352h11.101c-.729-.803-1.221-1.605-1.476-2.407-.22-.838-.329-1.586-.329-2.242.037-.693.11-1.24.22-1.64.109-.438.181-.675.218-.711zM20.696 17c.437-.73.656-1.513.656-2.352 0-.838-.22-1.604-.657-2.296A4.216 4.216 0 0019 10.656c-.693-.437-1.477-.656-2.352-.656-.838 0-1.622.219-2.351.656a4.722 4.722 0 00-1.695 1.696A4.5 4.5 0 0012 14.648c0 .875.2 1.678.602 2.407a5.377 5.377 0 001.695 1.695c.729.401 1.513.602 2.351.602.438 0 .857-.055 1.258-.165.401-.145.766-.31 1.094-.492l3.008 2.953 1.64-1.64L20.695 17zm-4.048 0c-.62 0-1.166-.219-1.64-.656a2.414 2.414 0 01-.656-1.696c0-.62.218-1.148.656-1.585.474-.475 1.02-.711 1.64-.711a2.14 2.14 0 011.641.71c.474.438.711.967.711 1.586 0 .657-.237 1.222-.71 1.696-.438.437-.985.656-1.642.656z"}})])
          )
        }
      }
    